/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/26
 * @updateTime 2021/8/26
 * @decription 补充担保信息 =》 请求js
 * @namespace request 命名空间
 */
import request from '@/api/axios';
export default {
    // 方法
    methods: {
        /**
         * 请求数据列表
         * @param {String} dbid 担保id
         * @returns {Promise}
         * */
        requestDataList(dbid) {
            return this.$axios.get('/ssbq/api/dbxxs', {
                bqid: dbid,
                isFirst: true,
                time: new Date().getTime()
            });
        },

        /**
         * 请求材料列表
         * @param {String} dbid 担保id
         * @returns {Promise}
         * */
        requestSccls(dbid) {
            return this.$axios.get('ssbq/api/sccls/bgsq/bg/bgsccls', {
                time: new Date().getTime(),
                dbid: dbid
            });
        },

        /**
         * 请求保全责任险
         * @param {String} bqid 保全id
         * @returns {Promise}
         * */
        requestBqzrx(bqid) {
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/bqsq/ccbqzrx',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 保全id
                        bqid: bqid
                    },
                }).then(res => {
                    resolve(res.data.bxgsVos);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },

        /**
         * 请求保存变更担保
         * @param {String} bqid 保全id
         * @param {Object} formData 表单数据
         * @returns {Promise}
         * */
        requestSaveBGDB(bqid, formData) {
            return request({
                url: 'ssbq/api/bqsqs/sqbgdb/bg/bcdb',
                method: 'put',
                params:{
                    time: new Date().getTime(),
                    bqid: bqid
                },
                data: formData
            })
        },

        /**
         * 请求提交变更担保
         * @param {String} bqid 保全id
         * @param {Object} data 变更担保数据
         * @returns {Promise}
         * */
        requestSubmitBGDB(bqid, data) {
            return request({
                url: 'ssbq/api/bqsqs/sqbgdb/tj',
                method: 'put',
                params:{
                    time: new Date().getTime(),
                    bqid: bqid
                },
                data: data
            })
        },

        /**
         * 请求变更材料状态
         * @param {String} bqid 保全id
         * @param {String} dbid 担保id
         * @param {Array<String>} clids 材料id集合
         * @returns {Promise}
         * */
        requestScclStatus(bqid, dbid, clids) {
            return request({
                url:'ssbq/api/sccls/bgsq/batchrecovery',
                method:'POST',
                params: {
                    time: new Date().getTime(),
                    bqid,
                    dbid
                },
                data: clids
            })
        },

        /**
         * 请求删除变更担保申请材料
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestBgDelSccl(params) {
            return request({
                url:'ssbq/api/sccls/bgsq/bg/delsccl',
                method:'delete',
                params: {
                    time: new Date().getTime(),
                    ...params
                }
            })
        },

        /**
         * 请求删除变更担保申请材料
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestDelSccl(params) {
            return request({
                url:'ssbq/api/sccls/bgsq/delsqcl',
                method:'delete',
                params: {
                    time: new Date().getTime(),
                    ...params
                }
            })
        },

        /**
         * 批量删除上传材料
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestBatchDelSccl(params) {
            return request({
                url:'ssbq/api/sccls/bgsq/batchdelsqcl',
                method:'delete',
                data: params
            })
        },
    }
};
